// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL ?? '',
  TIMEOUT: 30000, // 30 seconds
  //  HEADERS: {
  //   'Content-Type': 'application/json',
  // },
  HEADERS: {}
};

export const API_ENDPOINTS = {
  // Auth
  AUTH: {
    REGISTER: '/api/auth/register',
    LOGIN: '/api/auth/login',
    VERIFY_EMAIL: '/api/auth/verify-email',
    FORGOT_PASSWORD_CREW: '/api/auth/forgot-password',
    RESET_PASSWORD: '/api/auth/reset-password',
    SIGN_UP_1: '/api/auth/register-crew-step1',
    SIGN_UP_2: '/api/auth/register-crew-step2',
    SIGN_UP_3: '/api/auth/register-crew-step3'
  },

  // Projects
  PROJECTS: {
    CREATE: '/api/admin/create-project',
    GET: '/api/admin/get-project',
    MATCH_CREW: '/api/admin/match-crew',
    ASSIGN_CREW: '/api/admin/assignMatchCrew',
    MATCH_EQUIPMENT: '/api/admin/matchEquipments',
    ASSIGN_EQUIPMENT: '/api/admin/assignMatchEquipment',
    CREATE_BRIEF: '/api/admin/final-project-brief',
    GET_ALL_PROJECT: '/api/admin/get-projects',
    BULK_PREVIEW: '/api/admin/bulk-upload-project',
    BULK_SAVE: '/api/admin/bulk-upload-save-project',
  },

  // Crew
  CREW: {
    GET_ALL: '/api/admin/get-crew-members',
    GET_BY_ID: '/api/admin/crew-member',
    CREATE: '/api/admin/create-crew-member',
    UPDATE: '/api/admin/edit-crew-member',
    DELETE: '/api/admin/delete-crew-member',
    GET_NAMES: '/api/admin/get-crew-member-name',
    GET_CREW_COUNT: '/api/admin/get-crew-count',
     BULK_PREVIEW: '/api/admin/bulk-upload-crew',
    BULK_SAVE: '/api/admin/bulk-upload-save-crew',
  },

  // Equipment
  EQUIPMENT: {
    GET_ALL: '/api/admin/get-equipments',
    GET_BY_ID: '/api/admin/get-equipment-by-id',
    CREATE: '/api/admin/create_equipment',
    UPDATE: '/api/admin/update-equipment',
    DELETE: '/api/admin/delete-equipment',
    ASSIGN: '/api/admin/assign-equipment',
    RETURN: '/api/admin/return-equipment',
    BY_LOCATION: '/api/admin/equipment-by-location',
    GET_EQUIPMENT_REQUEST: '/api/admin/get-equipment-request',
    ACCEPT_REJECT_REQUEST: '/api/admin/accept-reject-request',
    CATEGORIES: '/api/admin/equipment-categories',
    BULK_PREVIEW: '/api/admin/bulk-upload-equipment',
    BULK_SAVE: '/api/admin/bulk-upload-save-equipment',
    PUBLISH: '/api/admin/publish',
    QUANTITY: '/api/admin/update-equipment-quantity',
  },

  // Master Data
  MASTER_DATA: {
    CATEGORIES: '/api/admin/equipment-categories',
    CHECKLISTS: '/api/admin/checklist-templates',
    ROLES: '/api/admin/crew-roles',
    SKILLS: '/api/admin/skills',
    CERTIFICATIONS: '/api/admin/certifications',
    EQUIPMENT_SUGGESTIONS: '/api/admin/equipment-autocomplete',
  },

  CREATOR: {
    CREW_AVAILABILITY: '/api/creator/availability',
    ADD_AVAILABILITY: '/api/creator/add-availability',
    UPCOMING_SHOOTS: '/api/creator/upcoming-accepted-project',
    GET_PROJECT_DETAILS: '/api/creator/project-details',
    PENDING_PROJECTS: '/api/creator/pending-projects',
    ACCEPT_PROJECT: '/api/creator/accept-project',
    DASHBOARD_COUNT: '/api/creator/dashboard-count',
    STATUS_COUNT: '/api/creator/status-count',
    DASHBOARD_DETAIL: '/api/creator/dashboard-detail',
    GET_CREW_EQUIPMENT: '/api/creator/equipment',
    GET_CREW_EQUIPMENT_COUNT: '/api/creator/get-crew-equipment-count',
    GET_MY_DETAILS: '/api/creator/get-profile-detail',
    EDIT_MY_DETAILS: '/api/creator/edit-profile',
    DELETE_EQUIPMENT: '/api/creator/equipment',
    // GET_MY_DETAILS: '/api/creator/get-profile-detail',
    EQUIPMENT_AUTOCOMPLETE: '/api/admin/equipment-autocomplete',
    MANAGEMENT: '/api/creator/equipment',
    UPLOAD_RECENT_WORK: '/api/creator/profile/files/recent_work',
    UPLOAD_CERTIFICATION: '/api/creator/profile/files/certifications',
    UPLOAD_RESUME: '/api/creator/profile/files/resume',
    UPLOAD_PORTFOLIO: '/api/creator/profile/files/portfolio',
    DELETE_FILES: '/api/creator/profile-file',
    RECENT_ACTIVITY: '/api/creator/recent-activity ',
    GET_ALL_EQUIPMENT: '/api/creator/get-equipments',
    SUBMIT_EQUIPMENT_REQUEST: '/api/creator/request-equipment',
    GET_MY_REQUESTS: '/api/creator/my-equipment-requests',
    DELETE_EQUIPMENT_PHOTO: '/api/creator/equipment/delete-photo',
  },

  LIVESTREAM: {
    // Projects
    PROJECTS: '/api/streams/projects',
    PROJECT_DETAILS: '/api/streams/projects/:id',

    // Stream lifecycle
    CREATE_STREAM: '/api/streams/projects/:id/stream',
    GET_STREAM: '/api/streams/:id',
    START_MEDIALIVE: '/api/streams/:id/start-medialive',
    STOP_STREAM: '/api/streams/:id/stop',

    // MediaLive & Status
    MEDIALIVE_DETAILS: '/api/streams/:id/medialive',
    STREAM_STATUS: '/api/streams/:id/status',

    // Destinations (Platform Connections)
    DESTINATIONS: '/api/streams/:id/destinations',
    DESTINATION_BY_ID: '/api/streams/destinations/:id',

    // Health
    STREAM_HEALTH: '/api/streams/:id/health',
  },
};
